/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The machine-readable outcome of the probe.
 */
export const ProbeOutcome = {
  Verified: "verified",
  CredentialDeleted: "credential_deleted",
  CredentialUnusable: "credential_unusable",
  InvalidResourceName: "invalid_resource_name",
  KeyNotFound: "key_not_found",
  PermissionDenied: "permission_denied",
  KeyUnusable: "key_unusable",
  UnsupportedAlgorithm: "unsupported_algorithm",
  AlgorithmMismatch: "algorithm_mismatch",
  SignatureInvalid: "signature_invalid",
  Unavailable: "unavailable",
  Unexpected: "unexpected",
} as const;
/**
 * The machine-readable outcome of the probe.
 */
export type ProbeOutcome = ClosedEnum<typeof ProbeOutcome>;

/**
 * Result of a live probe that Speakeasy can reach an external key and use it to sign.
 */
export type VerifyKmsKeyResult = {
  /**
   * Human-readable detail about the probe outcome, including the failure reason when it did not verify.
   */
  detail?: string | undefined;
  /**
   * The machine-readable outcome of the probe.
   */
  probeOutcome: ProbeOutcome;
  /**
   * Whether the key produced a signature that validated against its own public half.
   */
  verified: boolean;
};

/** @internal */
export const ProbeOutcome$inboundSchema: z.ZodMiniEnum<typeof ProbeOutcome> = z
  .enum(ProbeOutcome);

/** @internal */
export const VerifyKmsKeyResult$inboundSchema: z.ZodMiniType<
  VerifyKmsKeyResult,
  unknown
> = z.pipe(
  z.object({
    detail: z.optional(z.string()),
    probe_outcome: ProbeOutcome$inboundSchema,
    verified: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "probe_outcome": "probeOutcome",
    });
  }),
);

export function verifyKmsKeyResultFromJSON(
  jsonString: string,
): SafeParseResult<VerifyKmsKeyResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => VerifyKmsKeyResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'VerifyKmsKeyResult' from JSON`,
  );
}
